// extracted by mini-css-extract-plugin
module.exports = {"RSWbatterseaWrapper":"style_RSWbatterseaWrapper__dsXHO","RSWbatterseaBlock":"style_RSWbatterseaBlock__1lwDe"};